import styled from 'styled-components'

import { helpers } from 'styles'

export const Container = styled.div`
	font-weight: 400;
	background-color: ${helpers.color.warningContrast};
	border: 1px solid ${helpers.color.warning};
	color: ${helpers.color.text};
	border-radius: 4px;
	margin-bottom: 12px;
	width: 100%;
`
